import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { ActionForm } from '../components'
import { useAction, useCreateAction, useUpdateAction } from '../hooks/use-actions'

export function ActionFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isEdit = !!id

  const { data: action, isLoading } = useAction(id ? parseInt(id) : undefined)
  const createAction = useCreateAction()
  const updateAction = useUpdateAction()

  const handleSubmit = (data: { libelle: string; dureeMinutes: number; couleur?: string; actif: boolean }) => {
    if (isEdit) {
      updateAction.mutate(
        { id: parseInt(id!), data: { ...data, id: parseInt(id!) } },
        { onSuccess: () => navigate('/administration/actions') },
      )
    } else {
      createAction.mutate(data, {
        onSuccess: () => navigate('/administration/actions'),
      })
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={
          isEdit
            ? t('administration.sections.actions.editTitle', "Modifier l'action")
            : t('administration.sections.actions.createTitle', 'Créer une action')
        }
        backTo="/administration/actions"
      />
      <ActionForm
        action={action}
        onSubmit={handleSubmit}
        isPending={createAction.isPending || updateAction.isPending}
      />
    </div>
  )
}
